<div class="container-fluid">
    <div class="modal-header preview-header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
        <div class="preview-header__title">
            <h5>{{ data?.name }}</h5>
            <span class="preview-header__status">{{ displayStatus | uppercase }}</span>
        </div>
        <div class="preview-header__actions">
            <button mat-stroked-button color="primary" (click)="openInPandadoc()">
                <mat-icon>open_in_new</mat-icon>
                Open in PandaDoc
            </button>
            <button mat-stroked-button mat-dialog-close aria-label="Close dialog">
                Close
            </button>
        </div>
    </div>

    <div class="modal-body preview-body">
        <app-state-display
            *ngIf="isLoading || hasError"
            [type]="isLoading ? 'loading' : 'error'"
            loadingMessage="Loading PandaDoc document..."
            errorMessage="Failed to load the PDF"
            errorIcon="cloud_off">
        </app-state-display>

        <div class="preview-error-actions" *ngIf="hasError">
            <button mat-raised-button color="primary" (click)="loadDocument()">Retry</button>
        </div>

        <ngx-extended-pdf-viewer
            *ngIf="pdfSource && !hasError"
            [src]="pdfSource"
            useBrowserLocale="true"
            [zoom]="'80%'"
            [showPrintButton]="false"
            [showDownloadButton]="true"
            [filenameForDownload]="data?.name + '.pdf'"
            [showOpenFileButton]="false"
            [showRotateButton]="false"
            [showSecondaryToolbarButton]="false"
            [showDrawEditor]="false"
            [showTextEditor]="false"
            [showStampEditor]="false"
            [textLayer]="true">
        </ngx-extended-pdf-viewer>
    </div>
</div>
